import type { WizardFlowDefinition } from '@/modules/wizard/types/WizardFlowDefinition'

export const passwordSetupFlow: WizardFlowDefinition = {
  steps: [
    { id: 'password_setup', unless: ['hasPasswordSetupCompleted'] },
    { id: 'email_verification', unless: ['hasEmailVerified'] },
  ],
}
